import { Component, OnInit, ViewChild } from '@angular/core';
import { PerfectScrollbarConfigInterface } from 'ngx-perfect-scrollbar';
import { MatDialog, MatPaginator, PageEvent } from '@angular/material';
import swal from 'sweetalert2';
import { CarregandoService } from '../services/carregando.service';
import { NotificacaoService } from '../services/notificacao.service';
import { UtilitarioService } from '../services/utilitario.service';
import { PaginatorService } from '../services/paginator.service';
import { EtapaOcorrencia } from '../models/etapa-ocorrencia';
import { OcorrenciaService } from '../services/ocorrencia.service';
import { CadastrarEtapaOcorrenciaModalComponent } from '../modals/cadastrar-etapa-ocorrencia-modal/cadastrar-etapa-ocorrencia-modal.component';
import { OcorrenciaTipo } from '../models/ocorrencia-tipo';
import { OcorrenciaTipoService } from '../services/ocorrencia-tipo.service';
import { SetorService } from '../services/setor.service';
import { Setor } from '../models/setor';

declare const $: any;

@Component({
  selector: 'app-etapa-ocorrencia',
  templateUrl: './etapa-ocorrencia.component.html',
  styleUrls: ['./etapa-ocorrencia.component.scss']
})
export class EtapaOcorrenciaComponent implements OnInit {
  descricao: string;
  etapasOcorrencia: EtapaOcorrencia[] = [];
  setores: Setor[] = [];
  setorSelecionado;
  tiposOcorrencia: OcorrenciaTipo[] = [];
  tipoOcorrenciaSelecionado;
  carregando = true;
  campoOrdenacao = 'descricao';
  ordenarDesc = false;
  editavel = true;
  paginacao;
  listaDeItensPorPagina;
  itensPorPagina;
  situacao = [{ id: -1, descricao: 'Todos' }, { id: 1, descricao: 'Ativo' }, { id: 0, descricao: 'Inativo' }];
  situacaoSelecionada: number = 1;

  public config: PerfectScrollbarConfigInterface = {};

  constructor(
    private carregandoService: CarregandoService,
    public utilitarioService: UtilitarioService,
    private notificacaoService: NotificacaoService,
    public dialog: MatDialog,
    private paginatorService: PaginatorService,
    private ocorrenciaService: OcorrenciaService,
    private ocorrenciaTipoService: OcorrenciaTipoService,
    private setorService: SetorService
  ) { }

  ngOnInit(): void {
    const pagination = this.paginatorService.consultarPaginacao();

    this.paginacao = pagination.paginacao;
    this.itensPorPagina = pagination.itensPorPagina;
    this.listaDeItensPorPagina = pagination.listaDeItensPorPagina;

    this.buscarEtapas();
    this.buscarSetores();
  }

  filtra() {
    this.buscarEtapas();
  }

  buscarEtapas() {
    this.carregandoService.mostra('buscarEtapas');

    this.ocorrenciaService.consultarEtapasComPaginacao(this.descricao, this.paginacao.paginaAtual, this.itensPorPagina, this.campoOrdenacao, (this.ordenarDesc ? 'desc' : 'asc'), this.situacaoSelecionada, this.setorSelecionado, this.tipoOcorrenciaSelecionado).subscribe((data: any) => {
      this.etapasOcorrencia = data.itens;

      if (this.itensPorPagina > this.listaDeItensPorPagina[this.listaDeItensPorPagina.length - 1]) {
        this.itensPorPagina = 10;
      }

      this.paginacao.total = data.total;

      this.carregando = false;
      this.carregandoService.esconde('buscarEtapas');
    }, (erro) => {
      this.carregandoService.esconde('buscarEtapas');
      this.notificacaoService.erro(erro);
    });
  }

  buscarSetores() {
    this.carregandoService.mostra('buscarSetores');
    this.setorService.consultarSetores().subscribe((data: any) => {
      this.setores = data;
      this.carregandoService.esconde('buscarSetores');
    }, (erro) => {
      this.carregandoService.esconde('buscarSetores');
      this.notificacaoService.erro(erro);
    });
  }

  buscarTipoOcorrencia() {
    if (this.setorSelecionado === null || this.setorSelecionado === undefined) return;

    this.tipoOcorrenciaSelecionado = null;

    this.carregandoService.mostra('tipoOcorrencia');
    this.ocorrenciaTipoService.consultarPorIdSetor(this.setorSelecionado).subscribe((data: any) => {
      this.tiposOcorrencia = data;
      this.carregandoService.esconde('tipoOcorrencia');
    }, (erro) => {
      this.carregandoService.esconde('tipoOcorrencia');
      this.notificacaoService.erro(erro);
    });
  }

  mudaDePagina(pageEvent: PageEvent) {
    if (this.itensPorPagina !== pageEvent.pageSize)
      this.paginatorService.salvaPaginacao(pageEvent.pageSize);

    this.itensPorPagina = pageEvent.pageSize;
    this.paginacao.paginaAtual = pageEvent.pageIndex + 1;

    this.buscarEtapas();
  }

  excluirItem(idEtapa) {
    swal({
      title: 'Atenção!!',
      text: 'Deseja realmente excluir a etapa?',
      type: 'warning',
      showCancelButton: true,
      confirmButtonClass: 'btn btn-info',
      cancelButtonClass: 'btn btn-danger',
      confirmButtonText: 'Sim',
      cancelButtonText: 'Não',
      buttonsStyling: false
    }).then((result) => {
      if (result.value) {
        this.carregandoService.mostra('excluirItem');
        this.ocorrenciaService.excluirEtapa(idEtapa).subscribe(resp => {
          this.notificacaoService.sucesso('Etapa excluída com sucesso!!!');
          this.carregandoService.esconde('excluirItem');
          this.buscarEtapas();

        }, (erro) => {
          this.carregandoService.esconde('excluirItem');
          this.notificacaoService.erro(erro);
        });
      }
    });
  }

  novoItem() {
    const largura = Number(($('body').width()));
    const dialogRef = this.dialog.open(CadastrarEtapaOcorrenciaModalComponent, {
      width: largura > 930 ? '900px' : (($('body').width()).toString() + 'px'),
      data: {
        idSetor: this.setorSelecionado,
        idTipo: this.tipoOcorrenciaSelecionado
      },
      panelClass: 'modal-card'
    });

    dialogRef.afterClosed().subscribe((result: EtapaOcorrencia) => {
      if (result) {
        this.buscarEtapas();
      }
    });
  }

  editarItem(idEtapa: number) {
    const largura = Number(($('body').width()));
    const dialogRef = this.dialog.open(CadastrarEtapaOcorrenciaModalComponent, {
      width: largura > 930 ? '900px' : (($('body').width()).toString() + 'px'),
      data: { idEtapa },
      panelClass: 'modal-card'
    });

    dialogRef.afterClosed().subscribe((result: EtapaOcorrencia) => {
      if (result) {
        this.buscarEtapas();
      }
    });
  }
}
